import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataEntity_Detail_11_01_Interface } from 'src/app/Interface/DataEntity/11/01/DataEntity_Detail_11_01_Interface';
import { DataEntity_Main_11_01_Interface } from 'src/app/Interface/DataEntity/11/01/DataEntity_Main_11_01_Interface';
import { DataEntity_Resolution_11_01_Interface } from 'src/app/Interface/DataEntity/11/01/DataEntity_Resolution_11_01_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataEntity11_01Service {

  constructor(private http: HttpClient) { }

  GetSingle(Token: String,
    id: Number,
    dataentity_id: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Dataentityno11_01/GetSingle?token=" + Token
      + "&id=" + id
      + "&dataentity_id=" + dataentity_id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  Submit(
    model_temp: DataEntity_Main_11_01_Interface,
    detail: Array<DataEntity_Detail_11_01_Interface>,
    resolution: Array<DataEntity_Resolution_11_01_Interface>,
    DataEntity_id: number,
    Calibration_Id: number,
 
    DeviceSerial: string,
    DeviceCode: string,
    

    value1: string,
    value2: string,
    value3: string,

    Manufacture_txt: String,
    Model_txt: String,
    Type_txt: String,
    LabAddress_txt: String,


    Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var detail_list = []


    for (let item of detail) {
      detail_list.push({
        id: item.id,
        main_id: model_temp.id,

        sample: item.reference_Value,
        uncertainty: item.uncertainty,
        converage: item.converage,
      })
    }


    var model={
      id:model_temp.id,

      manufacture: Manufacture_txt,
      model: Model_txt,
      type: Model_txt,
      

      value1: value1,
      value2: value2,
      value3: value3,


      unit_nominal: model_temp.unit_nominal,
      
      temperature_Air_before: model_temp.temperature_Air_before +'',
      temperature_Air_after: model_temp.temperature_Air_after+'',

      humidity_Air_before: model_temp.humidity_Air_before+'',
      humidity_Air_after: model_temp.humidity_Air_after+'',

      pressure_before: model_temp.pressure_before+'',
      pressure_after: model_temp.pressure_after+'',

    }

    var body = {
      Calibration_id: Calibration_Id,
      dataentity_id: DataEntity_id,
      model: model,
      resolution : resolution,
      DeviceSerial: DeviceSerial,
      DeviceCode: DeviceCode,
      Token: Token,
      labAdderss: LabAddress_txt,
      detail: detail_list,
    }


    return this.http.post(environment.BaseUrl + "Daro/Dataentityno11_01/Submit", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  uploadFile(body,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno11_01/upload?token="+Token,body).pipe(
      map(data=>{
        return data
      })
    )
  }

  uploadPdf(body,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno11_01/uploadPdf?token="+Token,body).pipe(
      map(data=>{
        return data
      })
    )
  }

}
